import {connect} from "react-redux";
import Sidebar from "./Sidebar";
import {compose} from "redux";
import {toggleLeftMenu} from "../../../globalState/app/actions";
import {withRouter} from "react-router-dom";
import {logoutUser} from "../../../globalState/user/actions";
import {getObjectsPercentSelector} from "../../Objects/selectors";
import {getUserRoleSelector} from "../../../globalState/app/selectros";



let mapStateToProps =  (state) => {
    return {
        leftMenuActive: state.app.leftMenuActive,
        paymentType: state.object.payment_type,
        percentObjects: getObjectsPercentSelector(state),
        userRole: getUserRoleSelector(state),
        objectActive: state.object.active
    }
};

let mapDispatchToProps =  (dispatch) => {
    return {
    }
};

export default compose(connect(mapStateToProps, {mapDispatchToProps, toggleLeftMenu, logoutUser}), withRouter)(Sidebar);



